var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 14.9998V14.3332C23.8333 13.3997 23.8333 12.933 23.6517 12.5765C23.4919 12.2629 23.2369 12.0079 22.9233 11.8482C22.5668 11.6665 22.1001 11.6665 21.1667 11.6665H19.8333C18.8999 11.6665 18.4332 11.6665 18.0767 11.8482C17.7631 12.0079 17.5081 12.2629 17.3483 12.5765C17.1667 12.933 17.1667 13.3997 17.1667 14.3332V14.9998M18.8333 19.5832V23.7498M22.1667 19.5832V23.7498M13 14.9998H28M26.3333 14.9998V24.3332C26.3333 25.7333 26.3333 26.4334 26.0608 26.9681C25.8212 27.4386 25.4387 27.821 24.9683 28.0607C24.4335 28.3332 23.7335 28.3332 22.3333 28.3332H18.6667C17.2665 28.3332 16.5665 28.3332 16.0317 28.0607C15.5613 27.821 15.1788 27.4386 14.9392 26.9681C14.6667 26.4334 14.6667 25.7333 14.6667 24.3332V14.9998",
    stroke: "#535862",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton1);
export default __webpack_public_path__ + "static/media/button-1.2ac9fa93d4012acfc09be5f07c9d6f2f.svg";
export { ForwardRef as ReactComponent };